import {AuthEffect} from './auth.effect';
import {StatsEffects} from '../../statistics/store/effects/stats.effect';
import {ManagerEffect} from '../../managers/store/effects/manager.effect';
import {BrandEffect} from '../../brands/store/effects/brand.effect';
import {StoreEffects} from '../../stores/store/effects/store.effects';
import {PotentialEffects} from '../../potentials/store/effects/potential.effects';
import {SmsBlastEffects} from './sms-blast.effects';
import {CandidateEffect} from '../../candidates/store/effects/candidate.effect';
import {AvailabilityEffect} from '../../availabilities/store/effects/availability.effect';
import {FreelancerEffect} from '../../freelancers/store/effects/freelancer.effect';
import {ShiftEffect} from "../../shifts/store/effects/shift.effect";
import {InvoiceEffects} from '../../invoices/store/effects/invoice.effect';

export const effects = [
  AuthEffect,
  FreelancerEffect,
  StatsEffects,
  ManagerEffect,
  BrandEffect,
  StoreEffects,
  PotentialEffects,
  InvoiceEffects,
  SmsBlastEffects,
  CandidateEffect,
  AvailabilityEffect,
  ShiftEffect,
];



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/effects/index.ts